(ns common.schema.entities.email
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.entities.activity :as activity]
   [common.eid :as eid]))

(defn- system-controlled-email-field
  [[attribute field]]
  [attribute (assoc field :field/system-semantics su/system-controlled-optional-field-semantics)])

(def new-email
  (concat [[:email/to
            {:field/default-authorization {:access/read   :role/user
                                           :access/create :role/user
                                           :access/write  :role/user}
             :field/entity-types      [:entity.type/person]
             :field/translations      {:en "Email to"}
             :field/data-type         :data.type/email-multi
             :mandatory-entity-fields [:person/universal-email-address]
             :create-on-fly?          true
             :field/default-visibility {:editor :editor.type/multi-select
                                        :grid   :editor.type/multi-select
                                        :filter :filter.type/select
                                        :field-visibility :in-use-disabled}
             :value-type              :entity}]
           [:email/cc
            {:field/default-authorization {:access/read   :role/user
                                           :access/create :role/user
                                           :access/write  :role/user}
             :field/entity-types      [:entity.type/person]
             :field/translations      {:en "Cc"}
             :field/data-type         :data.type/email-multi
             :create-on-fly?          true
             :mandatory-entity-fields [:person/universal-email-address]
             :field/default-visibility {:editor :editor.type/multi-select
                                        :grid   :editor.type/multi-select
                                        :filter :filter.type/select
                                        :field-visibility :in-use-disabled}
             :value-type              :entity}]
           [:email/bcc
            {:field/default-authorization {:access/read   :role/user
                                           :access/write  :role/user
                                           :access/create :role/user}
             :field/entity-types      [:entity.type/person]
             :field/translations      {:en "Bcc"}
             :field/data-type         :data.type/email-multi
             :create-on-fly?          true
             :mandatory-entity-fields [:person/universal-email-address]
             :field/default-visibility {:editor :editor.type/multi-select
                                        :grid   :editor.type/multi-select
                                        :filter :filter.type/select
                                        :field-visibility :in-use-disabled}
             :value-type              :entity}]
           [:email/subject
            {:field/default-authorization {:access/read  :role/user
                                           :access/write :role/user}
             :field/entity-types       [:entity.type/person]
             :field/translations       {:en "Subject"}
             :field/data-type          :data.type/text-simple
             :create-on-fly?           true
             :field/default-visibility {:editor :editor.type/text-simple
                                        :grid   :editor.type/text-simple
                                        :filter :filter.type/text
                                        :field-visibility :in-use-disabled}
             :value-type               :entity}]
           [:email/body
            {:field/data-type             :data.type/text-richtext
             :field/default-authorization {:access/read  :role/user
                                           :access/write :role/user}
             :field/default-visibility    {:editor :editor.type/none
                                           :grid   :editor.type/none
                                           :filter :filter.type/text
                                           :field-visibility :in-use-disabled}
             :field/not-importable?       true
             :field/translations          {:en "Email body"}}]
           [:email/body-truncated?
            {:field/data-type          :data.type/boolean
             :field/default-authorization {:access/read  :role/user
                                           :access/write :role/system}
             :field/system-semantics   su/system-controlled-optional-field-semantics
             :field/translations       {:en "Body truncated?"}
             :field/default-visibility {:editor :editor.type/none
                                        :grid   :editor.type/none
                                        :filter :filter.type/boolean
                                        :field-visibility :in-use-disabled}}]
           [:email/privacy-status
            {:field/translations       {:en "Privacy status"}
             :field/default-authorization {:access/read  :role/user
                                           :access/write :role/user}
             :field/data-type          :data.type/keyword
             :field/default-visibility {:editor :editor.type/none
                                        :grid   :editor.type/none
                                        :filter :filter.type/text
                                        :field-visibility :in-use-disabled}}]]

          related-entities/related-entities
          activity/new-activity))

(def edit-email
  (concat (mapv system-controlled-email-field
                [[:email/to
                  {:field/translations       {:en "Email to"}
                   :field/default-authorization {:access/read  :role/guest-buy-side
                                                 :access/write :role/system}
                   :field/data-type          :data.type/text-simple
                   :field/default-visibility {:editor :editor.type/text-simple
                                              :grid   :editor.type/text-simple
                                              :filter :filter.type/text
                                              :field-visibility :in-use-disabled}}]
                 [:email/cc
                  {:field/translations       {:en "Cc"}
                   :field/default-authorization {:access/read  :role/guest-buy-side
                                                 :access/write :role/system}
                   :field/data-type          :data.type/text-simple
                   :field/default-visibility {:editor :editor.type/text-simple
                                              :grid   :editor.type/text-simple
                                              :filter :filter.type/text
                                              :field-visibility :in-use-disabled}}]
                 [:email/bcc
                  {:field/translations       {:en "Bcc"}
                   :field/default-authorization {:access/read  :role/guest-buy-side
                                                 :access/write :role/system}
                   :field/data-type          :data.type/text-simple
                   :field/default-visibility {:editor :editor.type/text-simple
                                              :grid   :editor.type/text-simple
                                              :filter :filter.type/text
                                              :field-visibility :in-use-disabled}}]
                 [:email/subject
                  {':field/translations      {:en "Subject"}
                   :field/default-authorization {:access/read  :role/guest-buy-side
                                                 :access/write :role/system}
                   :field/data-type          :data.type/text-simple
                   :field/default-visibility {:editor :editor.type/text-simple
                                              :grid   :editor.type/text-simple
                                              :filter :filter.type/text
                                              :field-visibility :in-use-disabled}}]
                 [:email/body
                  {:field/translations       {:en "Email body"}
                   :field/default-authorization {:access/read  :role/guest-buy-side
                                                 :access/write :role/system}
                   :field/data-type          :data.type/text-richtext
                   :field/default-visibility {:editor :editor.type/wysiwyg
                                              :grid   :editor.type/wysiwyg
                                              :filter :filter.type/text
                                              :field-visibility :in-use-disabled}}]])
          [[:email/privacy-status
            {:field/translations       {:en "Privacy status"}
             :field/default-authorization {:access/read  :role/user
                                           :access/write :role/user}
             :field/data-type          :data.type/keyword
             :field/default-visibility {:editor :editor.type/none
                                        :grid   :editor.type/none
                                        :filter :filter.type/text
                                        :field-visibility :in-use-disabled}}]]

          related-entities/related-entities
          activity/new-activity))

(defn no-access-to-private-email?
  [account email]
  (let [owner-id (eid/eid (:email/owner email))
        account-id (eid/eid account)]
    (and (= (:entity/type email) :entity.type/email)
         (= (:email/privacy-status email) :privacy-status/private)
         (not= owner-id account-id))))
